import {request} from './repository';


const serviceStatusRepository = {

    getStatuses(params) {
        return request.get('service-status', params);
    },
    getAllStatuses() {
        return request.get('service-status');
    }
}

export default serviceStatusRepository;
